var _style, _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTabOrders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#999999;}\n\t.st1{display:none;}\n\t.st2{display:inline;fill:none;stroke:#999999;stroke-linecap:round;stroke-linejoin:round;}\n\t.st3{display:inline;fill:none;stroke:#999999;}\n\t.st4{display:inline;fill:#999999;}\n\t.st5{display:inline;fill:none;stroke:#222222;stroke-linecap:round;stroke-linejoin:round;}\n\t.st6{display:inline;fill:none;stroke:#222222;}\n\t.st7{display:inline;fill:#222222;}\n\t.st8{display:inline;fill:#222222;stroke:#222222;stroke-linecap:round;stroke-linejoin:round;}\n\t.st9{display:inline;fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.7,8.2H7.5C7.2,8.2,7,8.4,7,8.7s0.2,0.5,0.5,0.5h6.2c0.3,0,0.5-0.2,0.5-0.5S13.9,8.2,13.7,8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.7,10.9H7.5c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h6.2c0.3,0,0.5-0.2,0.5-0.5S13.9,10.9,13.7,10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.6,13.6H7.5c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h3.1c0.3,0,0.5-0.2,0.5-0.5S10.9,13.6,10.6,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18,4.2C18,4.2,18,4.2,18,4.2l-3,0l0,0c0,0,0,0,0,0H6C5.5,4.2,5,4.4,4.6,4.8C4.2,5.2,4,5.7,4,6.3v11.9 c0,0.5,0.2,1.1,0.6,1.4C5,20,5.5,20.3,6,20.3h9c0.5,0,1.1-0.2,1.4-0.6c0.4-0.4,0.6-0.9,0.6-1.5v-5.3c0.3,0.2,0.6,0.3,1,0.3 c1.1,0,2-0.9,2-2v-5C20,5.1,19.1,4.2,18,4.2z M15.7,19c-0.2,0.2-0.4,0.3-0.7,0.3H6c-0.3,0-0.5-0.1-0.7-0.3C5.1,18.8,5,18.5,5,18.2 V6.3C5,6,5.1,5.7,5.3,5.5C5.5,5.3,5.7,5.2,6,5.2h9c0.3,0,0.5,0.1,0.7,0.3C15.9,5.7,16,6,16,6.3v5c0,0,0,0,0,0v7 C16,18.5,15.9,18.8,15.7,19z M19,11.2c0,0.6-0.4,1-1,1c-0.5,0-1-0.4-1-1v-5c0,0,0,0,0,0v0c0-0.6,0.4-1,1-1s1,0.4,1,1V11.2z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_1",
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M16.5,18.2c0,0.4-0.2,0.8-0.4,1.1c-0.3,0.3-0.7,0.5-1.1,0.5H6c-0.4,0-0.8-0.2-1.1-0.5 c-0.3-0.3-0.4-0.7-0.4-1.1V6.3c0-0.4,0.2-0.8,0.4-1.1C5.2,4.9,5.6,4.7,6,4.7h9c0.4,0,0.8,0.2,1.1,0.5c0.3,0.3,0.4,0.7,0.4,1.1V18.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.5,8.7h6.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.5,11.4h6.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.5,14.1h3.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M18,4.7L18,4.7c0.8,0,1.5,0.7,1.5,1.5v5c0,0.8-0.7,1.5-1.5,1.5l0,0c-0.8,0-1.5-0.7-1.5-1.5v-5 C16.5,5.4,17.2,4.7,18,4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M18,4.2h-3l2,1.5L18,4.2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_3",
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M16.5,18.2c0,0.4-0.2,0.8-0.4,1.1c-0.3,0.3-0.7,0.5-1.1,0.5H6c-0.4,0-0.8-0.2-1.1-0.5 c-0.3-0.3-0.4-0.7-0.4-1.1V6.3c0-0.4,0.2-0.8,0.4-1.1C5.2,4.9,5.6,4.7,6,4.7h9c0.4,0,0.8,0.2,1.1,0.5c0.3,0.3,0.4,0.7,0.4,1.1V18.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M18,4.7L18,4.7c0.8,0,1.5,0.7,1.5,1.5v5c0,0.8-0.7,1.5-1.5,1.5l0,0c-0.8,0-1.5-0.7-1.5-1.5v-5 C16.5,5.4,17.2,4.7,18,4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M18,4.2h-3l2,1.5L18,4.2z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_2",
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M16.5,18.2c0,0.4-0.2,0.8-0.4,1.1c-0.3,0.3-0.7,0.5-1.1,0.5H6c-0.4,0-0.8-0.2-1.1-0.5 c-0.3-0.3-0.4-0.7-0.4-1.1V6.3c0-0.4,0.2-0.8,0.4-1.1C5.2,4.9,5.6,4.7,6,4.7h9c0.4,0,0.8,0.2,1.1,0.5c0.3,0.3,0.4,0.7,0.4,1.1V18.2 z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_4",
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M7.5,8.7h6.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M7.5,11.4h6.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M7.5,14.1h3.1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTabOrders);
export default __webpack_public_path__ + "static/media/icon-tab-orders.ef924a82103ea965c3375183a64a71c5.svg";
export { ForwardRef as ReactComponent };